import { render, staticRenderFns } from "./ClassGrade.vue?vue&type=template&id=11947207&scoped=true"
import script from "./ClassGrade.vue?vue&type=script&lang=js"
export * from "./ClassGrade.vue?vue&type=script&lang=js"
import style0 from "./ClassGrade.vue?vue&type=style&index=0&id=11947207&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11947207",
  null
  
)

export default component.exports